import PropTypes from 'prop-types'
import { rdtDurationPropType } from './rdt-duration-prop-type'

/**
 * @typedef {Object} RdtDailyActivities
 * @property {rdtDurationPropType} [driving] - The duration object of driving activity
 * @property {rdtDurationPropType} [otherWork] - The duration object of otherWork activity
 * @property {rdtDurationPropType} [standby] - The duration object of standby activity
 */
export const rdtDailyActivitiesPropType = PropTypes.shape({
    driving: rdtDurationPropType,
    otherWork: rdtDurationPropType,
    standby: rdtDurationPropType
})
